import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Breadcrumbs, Container } from 'telia-front-react';
import BreadcrumbStore from '../stores/BreadcrumbStore';
import ContentStore from '../stores/ContentStore';
import { TranslationsContext } from '@teliaee/telia-translate';

interface BreadcrumbContainerProps {
  breadcrumbStore?: BreadcrumbStore;
  contentStore?: ContentStore;
}

@observer
class BreadcrumbContainer extends React.Component<BreadcrumbContainerProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  public render() {
    const translate = this.context.translate;
    const {
      breadcrumbStore,
      contentStore: {
        currentPageContent: { whiteBreadCrumbs, hideBreadCrumbs },
        isFetching,
        notFound
      }
    } = this.props;

    if (breadcrumbStore.hidden || hideBreadCrumbs || isFetching || notFound) {
      return null;
    }
    return (
      <Container>
        <Breadcrumbs aria-label={translate('breadcrumbs.label')} items={breadcrumbStore.breadcrumbs} {...(whiteBreadCrumbs && { theme: 'dark' })} />
      </Container>
    );
  }
}

export default inject('breadcrumbStore', 'contentStore')(BreadcrumbContainer);
